<template>
  <div
    class="
      cbg-white-container
      input-container
      theme--light
      v-card
      p-16
      border-card
    "
  >
    <v-col cols="12" class="px-0">
      <h5 class="my-3">Dashboard</h5>
    </v-col>
    <v-row class="m-0 border d-align border-radius-4">
      <v-col cols="12" md="6">
        <h5 class="mb-0">Filter</h5>
        <p class="p-clr">In publishing and graphic design lorem ipsum</p>
        <v-row>
          <v-col cols="12" md="6">
            <div class="position-relative">
              <label for>Select State</label>
              <select
                name
                id
                class="form-control"
                v-model="state"
                @change="changeCity()"
              >
                <option value="all">All</option>
                <option :value="state" v-for="state in states" :key="state">
                  {{ state }}
                </option>
              </select>
              <span class="drop-icon">
                <i
                  aria-hidden="true"
                  class="
                    v-icon
                    mdi mdi-menu-down
                    theme--light
                    position-absolute
                  "
                ></i>
              </span>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="position-relative">
              <label for>Select City</label>
              <select
                name
                id
                class="form-control"
                v-model="city"
                @change="getCounts()"
              >
                <option value="all">All</option>
                <option :value="city" v-for="city in cities" :key="city">
                  {{ city }}
                </option>
              </select>
              <span class="drop-icon">
                <i
                  aria-hidden="true"
                  class="
                    v-icon
                    mdi mdi-menu-down
                    theme--light
                    position-absolute
                  "
                ></i>
              </span>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <label for>Search by pincode</label>
            <input
              class="form-control"
              v-model="pincode"
              placeholder="Search by city or pincode"
            />
          </v-col>
          <v-col cols="12" md="6" class="calendar-point">
            <label for>Date Range</label>
            <datepicker
              v-model="countDateRange"
              @input="filterCountDate()"
              ref="datepicker"
              :max-date="new Date()"
              is-range
              :masks="{ input: 'DD/MM/YYYY' }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  :value="
                    !!inputValue.start && !!inputValue.end
                      ? inputValue.start + ' - ' + inputValue.end
                      : 'DD/MM/YYYY'
                  "
                  v-on="inputEvents.start"
                  class="form-control pos-r"
                  placeholder="DD/MM/YYYY"
                />
                <div
                  v-if="!!inputValue.start && !!inputValue.end"
                  class="cross-svg"
                  @click="(countDateRange = null), getCounts()"
                >
                  <crossSVG />
                </div>
              </template>
            </datepicker>
            <div class="calendarsvg userinputcalendar pos-a">
              <calendarSVG />
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <v-row>
          <v-col cols="12" md="6" class="text-center">
            <h6 class="font-weight-normal">
              Total number of subscribed by SEVA
            </h6>
            <h5>{{ counts.subscriptions_count }}</h5>
          </v-col>
          <v-col cols="12" md="6" class="text-center">
            <h6 class="font-weight-normal">
              Total number of on-boarded by SEVA
            </h6>
            <h5>{{ counts.seva_onboarded }}</h5>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row
      class="mx-0 mt-5 border d-align border-radius-4"
      style="border-bottom-right-radius: 0; border-bottom-left-radius: 0"
    >
      <v-row class="m-0">
        <v-col cols="12" md="3" class="calendar-point">
          <label for>Date</label>
          <datepicker
            v-model="date"
            @input="filterDate()"
            ref="datepicker"
            :max-date="new Date()"
            :masks="{ input: 'DD/MM/YYYY' }"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                class="form-control pos-r"
                placeholder="DD/MM/YYYY"
                :value="inputValue"
                v-on="inputEvents"
              />
              <!-- <div v-if="inputValue" class="cross-svg" @click="dates = null">
                <crossSVG />
              </div> -->
            </template>
          </datepicker>
          <div class="calendarsvg userinputcalendar pos-a">
            <calendarSVG />
          </div>
        </v-col>
        <v-col sm="12" md="3">
          <div class="position-relative">
            <label for>Role</label>
            <select
              name
              id
              class="form-control"
              v-model="role"
              @change="getCalculatedCounts"
            >
              <option value="all">All</option>
              <option value="doctor">Doctor</option>
              <option value="pharmacy">Pharmacy</option>
              <option value="diagnostics-lab">Diagnostic</option>
              <option value="bloodbank">Bloodbank</option>
              <option value="ambulance">Ambulance</option>
            </select>
            <span class="drop-icon">
              <i
                aria-hidden="true"
                class="v-icon mdi mdi-menu-down theme--light position-absolute"
              ></i>
            </span>
          </div>
        </v-col>

        <v-col sm="12" md="6" class="flex-end">
          <v-btn
            v-if="role != 'all'"
            class="btn btn-primary export-height"
            @click="exportModal = true"
            >Export</v-btn
          >
          <label for></label>
          <h4 class="font-weight-normal mt-4 p-clr" v-if="role != 'all'">
            {{ ratios[role] }}
          </h4>
        </v-col>
      </v-row>
    </v-row>
    <v-row
      class="border mx-0 border-radius-4"
      style="
        border-top: unset !important;
        border-top-right-radius: 0;
        border-top-left-radius: 0;
      "
    >
      <v-col cols="12" md="6">
        <p>
          Total subscribed via Docsmart:
          <span class="fz-18 font-weight-bold">
            {{ calculatedCounts.subscribed_via_docsmart }}</span
          >
        </p>
        <p>
          Total subscribed + on boarded via SEVA:
          <span class="fz-18 font-weight-bold">
            {{ calculatedCounts.onboarded_subscribed_on_same_day }}</span
          >
        </p>
        <p>
          Total only subscribed via SEVA:
          <span class="fz-18 font-weight-bold">
            {{ calculatedCounts.only_subscribed_via_seva }}</span
          >
        </p>
        <p>
          Total only onboarded via SEVA:
          <span class="fz-18 font-weight-bold">
            {{ calculatedCounts.only_onboarded_via_seva }}</span
          >
        </p>
        <p>
          Total unaccounted onboardings:
          <span class="fz-18 font-weight-bold">
            {{ calculatedCounts.unaccounted_onboarding_count }}</span
          >
        </p>
      </v-col>
      <v-col cols="12" md="6" v-if="role != 'all'">
        <v-col cols="12" md="8" offset-lg="4" class="border text-center py-4">
          <p class="mb-0">Total subscription amount</p>
          <h5>{{ calculatedCounts.total_subscription_amount }}</h5>
        </v-col>

        <v-col
          cols="12"
          md="8"
          offset-lg="4"
          class="border text-center py-4 mt-4"
        >
          <p class="mb-0">Total subscription amount towards SEVA</p>
          <h5>{{ calculatedCounts.subscription_amount_towards_seva }}</h5>
        </v-col>

        <v-col
          cols="12"
          md="8"
          offset-lg="4"
          class="border text-center py-4 mt-4"
        >
          <p class="mb-0">Total onboarding amount towards SEVA</p>
          <h5>{{ calculatedCounts.onboarding_amount_towards_seva }}</h5>
        </v-col>
      </v-col>
    </v-row>
    <v-dialog
      v-if="exportModal"
      v-model="exportModal"
      width="600px"
      content-class="v-dialog-lg seva-modal"
      persistent
    >
      <v-card class="min-height">
        <nav class="border-bottom theme--dark p-2 pl-1" data-booted="true">
          <div class="v-toolbar__content">
            <div class="flex-column">
              <div class="v-toolbar__title pl-1">Export</div>
            </div>
            <div class="spacer"></div>
            <button
              type="button"
              class="v-btn v-btn--icon theme--dark"
              @click="closeModal()"
            >
              <div class="v-btn__content cursor">
                <img src="/img/avatars/remove.png" />
              </div>
            </button>
          </div>
        </nav>
        <v-card-text class="scrolling">
          <v-row class="m-0">
            <v-col
              cols="12"
              md="12"
              class="pl-1 pt-1 pr-1 calendar-point position-relative"
            >
              <label for>Date Range</label>
              <datepicker
                v-model="dateRange"
                ref="datepicker"
                :max-date="new Date()"
                is-range
                :masks="{ input: 'DD/MM/YYYY' }"
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <input
                    :value="
                      !!inputValue.start && !!inputValue.end
                        ? inputValue.start + ' - ' + inputValue.end
                        : 'DD/MM/YYYY'
                    "
                    v-on="inputEvents.start"
                    class="form-control pos-r"
                    placeholder="DD/MM/YYYY"
                  />
                  <div
                    v-if="!!inputValue.start && !!inputValue.end"
                    class="cross-svg"
                    @click="dateRange = null"
                  >
                    <crossSVG />
                  </div>
                </template>
              </datepicker>
              <div class="calendarsvg userinputcalendar pos-a">
                <calendarSVG />
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-3 pb-3">
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            class="mr-3 pl-5 pr-5 range-btn"
            @click.stop="closeModal()"
            >Cancel</v-btn
          >
          <v-btn color="success" class="range-btn mr-2" @click="downloadCsv()"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
import statesAndCities from "@/data/statesAndCities";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
export default {
  data() {
    return {
      dayJS,
      exportModal: false,
      state: "all",
      search: null,
      date: new Date(),
      counts: { subscriptions_count: 0, seva_onboarded: 0 },
      calculatedCounts: {},
      role: "all",
      ratios: {
        doctor: "Subcription : Onboarding : 1:10",
        pharmacy: "Subcription : Onboarding : 2:10",
        "diagnostics-lab": "Subcription : Onboarding : 2:10",
        ambulance: "Subcription : Onboarding : 2:10",
        bloodbank: "Subcription : Onboarding : 1:10",
      },
      dateRange: null,
      dates: null,
      exportRole: null,
      statesAndCities: statesAndCities,
      states: [],
      cities: [],
      city: "all",
      pincode: "",
      countDateRange: null,
    };
  },
  components: {
    ...pickSvg("crossSVG", "calendarSVG"),
    Datepicker,
  },
  methods: {
    filterCountDate() {
      this.getCounts();
    },
    changeCity() {
      this.cities = [];
      this.statesAndCities.states.forEach((state) => {
        if (state.name == this.state) {
          state.cities.forEach((city) => {
            this.cities.push(city.name);
          });
        }
      });
      this.getCounts();
    },
    closeModal() {
      this.dateRange = null;
      this.exportRole = null;
      this.exportModal = false;
    },
    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    downloadCsv() {
      if (!this.dateRange) {
        return false;
      }
      this.csvLoader = true;
      const params = {
        start_date: new Date(this.dateRange.start).toISOString(),
        end_date: new Date(this.dateRange.end).toISOString(),
        role: this.role,
      };
      let url = `${config.BASE_URL}api/v2/admin/seva/dashboard/calculated-counts/export`;
      this.$http.post(url, params).then((response) => {
        if (response.body.status) {
          this.csvLoader = false;
          const data = response.data.data;
          this.download(data.fileName, data.csv);
        }
      });
    },
    getCounts() {
      let params = {
        state: this.state,
        city: this.city,
        pincode: this.pincode,
      };

      if (this.countDateRange) {
        params.start_date = new Date(this.countDateRange.start).toISOString();
        params.end_date = new Date(this.countDateRange.end).toISOString();
      }

      let url = `${config.BASE_URL}api/v2/admin/seva/dashboard/counts`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.counts = response.body.data;
        }
      });
    },
    getCalculatedCounts() {
      let params = {
        role: this.role,
      };
      if (this.date) {
        params.date = new Date(this.date).toISOString();
      }
      let url = `${config.BASE_URL}api/v2/admin/seva/dashboard/calculated-counts`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.calculatedCounts = response.body.data;
        }
      });
    },
    filterDate() {
      this.getCalculatedCounts();
    },
  },
  created() {
    this.states = this.statesAndCities.states.map((state) => {
      return state.name;
    });
    this.date = new Date(
      this.dayJS(new Date()).subtract(1, "day").startOf("day")
    );
  },
  mounted() {
    this.getCounts();
    this.getCalculatedCounts();
  },
};
</script>
<style lang="scss" scoped>
.export-height {
  margin-top: 1.8rem;
  height: 40px !important;
  margin-right: 1rem;
}

.v-dialog {
  &.seva-modal {
    .theme--dark {
      background-color: #e0e0e0 !important;
      border-color: #e0e0e0 !important;
    }
    .v-btn {
      img {
        width: 22px;
        margin-right: 0.4rem;
      }
      &.range-btn {
        height: 40px;
        padding-left: 1rem !important;
        padding-right: 1rem !important;
      }
    }
  }
}
</style>